import styled from "styled-components";
import { Modal as AntModal, } from 'antd';

export const Modal = styled(AntModal)`
text-align: center !important;

    .ant-modal-title {
        color: #faad14;
    }
`;

export const Text = styled.div`
padding-top: 10px;
padding-bottom: 20px;
`;